import { render, staticRenderFns } from "./ColorsPieChart.vue?vue&type=template&id=60314638&"
import script from "./ColorsPieChart.vue?vue&type=script&lang=js&"
export * from "./ColorsPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports